module.exports = __webpack_public_path__ + "static/media/redo.3f64cf62.svg";